(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/digital-tickets-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/digital-tickets-form.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const BillingInformation = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation.BillingInformation;
const RegisterNew = svs.ticket_partner.digitalTickets.digitalTicketsForm.registerNew.RegisterNew;
const SelectDigitalTickets = svs.ticket_partner.digitalTickets.digitalTicketsForm.selectDigitalTickets.SelectDigitalTickets;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridRow = _svs$ui$ReactGrid.GridRow,
  GridCol = _svs$ui$ReactGrid.GridCol;
const ButtonRowSubmit = svs.ticket_partner.sharedComponents.buttonRow.ButtonRowSubmit;
const _svs$ticket_partner$d = svs.ticket_partner.digitalTickets.constants.FORMS,
  HEADER = _svs$ticket_partner$d.HEADER,
  ORDER_LABEL = _svs$ticket_partner$d.ORDER_LABEL;
const Form = svs.ui.reactForm.Form;
const LoginRegister = svs.ticket_partner.digitalTickets.loginRegister.LoginRegister;
const _React = React,
  useState = _React.useState,
  Fragment = _React.Fragment,
  useContext = _React.useContext;
const DIGITAL_TICKETS_RECEIPT = svs.ticket_partner.constants.routes.DIGITAL_TICKETS_RECEIPT;
const ORDER_SUCCESS = svs.ticket_partner.digitalTickets.actions.ORDER_SUCCESS;
const DigitalTicketsForm = _ref => {
  let history = _ref.history;
  const _svs$ticket_partner$u = svs.ticket_partner.useUserContext(),
    isLoggedIn = _svs$ticket_partner$u.isLoggedIn,
    companyDetailsPromise = _svs$ticket_partner$u.companyDetailsPromise;
  const _useContext = useContext(svs.ticket_partner.DigitalTicketsContext),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isRegisterNew = _useState2[0],
    setIsRegisterNew = _useState2[1];
  const handleSubmit = async (e, formData) => {
    e && e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let isValid = _ref2.isValid;
      return !isValid;
    })) {
      return;
    }
    const orderCb = async () => {
      try {
        let digitalOrderRequest;
        if (isLoggedIn) {
          const _await$companyDetails = await companyDetailsPromise,
            companyDetails = _await$companyDetails.companyDetails;
          digitalOrderRequest = svs.ticket_partner.digitalTickets.utils.createDigitalOrderRequest(state, companyDetails);
        } else {
          digitalOrderRequest = svs.ticket_partner.digitalTickets.utils.createDigitalOrderRequest(state);
        }
        await svs.ticket_partner.services.createDigitalOrder(digitalOrderRequest);
        dispatch({
          type: ORDER_SUCCESS
        });
        history.push(DIGITAL_TICKETS_RECEIPT);
      } catch (e) {
        const errorMessage = svs.ticket_partner.services.mapDigitalOrderError(e);
        svs.ticket_partner.utils.showErrorDialog(errorMessage);
      }
    };
    const sum = Object.values(state.articles).reduce((acc, _ref3) => {
      let price = _ref3.price,
        count = _ref3.count;
      return price * count + acc;
    }, 0);
    const rows = Object.values(state.articles).filter(_ref4 => {
      let count = _ref4.count;
      return count > 0;
    }).map(_ref5 => {
      let articleId = _ref5.articleId,
        count = _ref5.count;
      return {
        articleId,
        count
      };
    });
    svs.ticket_partner.utils.showSummaryDialog(orderCb, {
      sum,
      rows
    }, svs.ticket_partner.data.articles.ticketsDigital);
  };
  return React.createElement(Fragment, null, React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 8
    },
    md: {
      col: 10
    },
    sm: {
      col: 12
    },
    xl: {
      col: 6
    },
    xs: 12
  }, React.createElement("h1", null, HEADER), React.createElement(SelectDigitalTickets, null), isRegisterNew ? React.createElement(RegisterNew, null) : null, isLoggedIn || isRegisterNew ? React.createElement(BillingInformation, null) : null)), isLoggedIn || isRegisterNew ? React.createElement(ButtonRowSubmit, {
    label: ORDER_LABEL
  }) : null), isLoggedIn || isRegisterNew ? null : React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 8
    },
    md: {
      col: 10
    },
    sm: {
      col: 12
    },
    xl: {
      col: 6
    },
    xs: 12
  }, React.createElement(LoginRegister, {
    handleNewCustomer: () => setIsRegisterNew(true)
  }))));
};
svs.ticket_partner.digitalTickets.DigitalTicketsForm = DigitalTicketsForm;

 })(window);